var render = function render(){var _vm=this,_c=_vm._self._c;return _c('ModalWithButton',{attrs:{"name":_vm.modalName,"title":"Crear nuevo precio","button_title":"Crear nuevo precio"},on:{"cerrar":function($event){return _vm.cerrar()}}},[_c('Form',{attrs:{"data":_vm.data},on:{"terminado":function($event){return _vm.addPrice()}}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }